import React from 'react';
import { Flex } from '@chakra-ui/react';
import {
  Heading,
  Text,
} from '@ayble-health/dashboard-components';
import type { ProviderVisit } from '../../models/providerHome';
import { DayTimeline } from './DayTimeline';
import { INK, SUBTLE } from './tokens';

type Props = {
  visits: ProviderVisit[];
  showNowLine: boolean;
};

export const AppointmentsColumn = ({ visits, showNowLine }: Props) => {
  if (visits.length === 0) {
    return (
      <Flex direction="column" align="center" pt={16} pb={8} px={4}>
        <Heading size="xs" color={INK} textAlign="center" mb={2}>
          No appointments scheduled
        </Heading>
        <Text color={SUBTLE} fontSize="sm" textAlign="center" maxW="240px">
          Enjoy the open time — check back tomorrow for what's coming up.
        </Text>
      </Flex>
    );
  }
  return <DayTimeline visits={visits} showNowLine={showNowLine} />;
};
